export const configUat = {
  baseUrl: "https://pub-kong-testenv02.uat.aurora.io/uat-v1",
};
